
import { useQueryClient } from '@tanstack/vue-query'
import { useErrorStore } from 'Store/errors/errorStore'
import { getMessage, onSettledWrapperFn } from './utils'
import type { SetDataOptions, Updater } from '@tanstack/vue-query'
import type { CreateQueryOptions, QueryBaseHookOptions } from '../../../types/utils/network/querykit/queryTypes'
/* eslint-disable @typescript-eslint/no-explicit-any */
export function createBaseQuery(
    options: CreateQueryOptions,
    useQueryHook: (options: any) => any
): any {
    const { primaryKey, queryFn, ...defaultOptions } = options

    const getPrimaryKey = () => primaryKey

    const getKey = (variables?: any) =>
        typeof variables === 'undefined' ? [primaryKey] : [primaryKey, variables]

    function useGeneratedQuery(options?: QueryBaseHookOptions) {
        const { variables, ...restOptions } = options || {}
        const errorStore = useErrorStore()
        const queryClient = useQueryClient()
        const queryKey = getKey(variables)

        const { enabled, message, onSettled, ...mergedOptions } = {
            ...defaultOptions,
            ...restOptions,
            queryFn,
            queryKey,
        }

        const setData = (updater: Updater<any, any>, options?: SetDataOptions) =>
            queryClient.setQueryData(queryKey, updater, options)

        const result = useQueryHook({
            ...mergedOptions,
            enabled:
                typeof enabled === 'function'
                    ? enabled(queryClient.getQueryData(queryKey), variables)
                    : enabled,
            onSettled: (data, error) =>
                onSettledWrapperFn(data, error, () => getMessage(queryClient.getQueryState(queryKey), variables, message), onSettled, errorStore.pushError)
        })

        return Object.assign(result, { queryKey, setData })
    }

    useGeneratedQuery.getPrimaryKey = getPrimaryKey
    useGeneratedQuery.getKey = getKey
    useGeneratedQuery.queryFn = queryFn

    return useGeneratedQuery
}
/* eslint-enable @typescript-eslint/no-explicit-any */